import React, { useEffect, useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import { useTheme } from "@material-ui/core/styles";
import { useDispatch, useSelector } from "react-redux";
import { useSetState } from "Helpers/Hooks";
import DialogContent from "@material-ui/core/DialogContent";
import Input from "Components/Input/Input";
import MuiAutoComplete from "Components/MuiAutoComplete/MuiAutoComplete";
import Grid from "@material-ui/core/Grid";
import Translator from "Languages/Utility/Translator";
import { getMahdoode, updatePriceBrandGroup } from "Stores/actions";
import { read } from "Helpers/LocalStorage";
import showNotify from "Helpers/Notify";
import * as R from "ramda";
import MuiButton from "Components/MuiButton/MuiButton";
import { toggleNChangeType, toggleNPercentRiyal } from "Constants/Constants";
import { DialogActions } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import MuiRadioGroup from "Components/MuiRadioGroup/MuiRadioGroup";

let _toggleNChangeType = toggleNChangeType;

function ChangeGroupPrice(props) {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const {
    brandYaraghList,
    selectedBazsho,
    selectedBrandYaragh,
    mahdoodeDataSearch,
    mahdoodeDataPagination,
  } = useSelector((state) => ({
    brandYaraghList: state.yaragh.brandYaraghList,
    selectedBazsho: state.yaragh.selectedBazsho,
    selectedBrandYaragh: state.yaragh.selectedBrandYaragh,
    mahdoodeDataPagination: state.yaragh.mahdoodeDataPagination,
    mahdoodeDataSearch: state.yaragh.mahdoodeDataSearch,
  }));
  const dispatch = useDispatch();
  const [formValid, setFormValid] = useState({});
  const [loading, setLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [checkValid, setCheckValid] = useState(false);
  const [controls, setControls] = useSetState({
    yaraghBrand: {
      type: "select",
      row: 1,
      selectItems: [],
      value: "",
      validation: {
        required: true,
      },
      col: {
        sm: 12,
        xs: 12,
      },
    },
    price: {
      type: "price",
      row: 1,
      value: 0,
      validation: {
        required: true,
        isPrice: true,
        notZero: true,
      },
      col: {
        sm: 12,
        xs: 12,
      },
      relation: "isPercent",
    },
    isPercent: {
      type: "toggle",
      row: 2,
      relation: "price",
      arrayItems: toggleNPercentRiyal,
      value: toggleNPercentRiyal[0],
      ValidationPlus: {
        isPercent: true,
      },
      validation: {
        required: true,
      },
      col: {
        sm: 6,
        xs: 6,
      },
    },
    changeType: {
      type: "toggle",
      row: 1,
      arrayItems: [],
      value: null,
      validation: {
        required: true,
      },
      col: {
        sm: 12,
        xs: 12,
      },
    },
  });

  useEffect(() => {
    if (brandYaraghList) {
      setControls({ yaraghBrand: { value: brandYaraghList[0] } });
      setControls({ yaraghBrand: { selectItems: brandYaraghList } });
    }
  }, [brandYaraghList]);

  const setValue = (name, value, validation) => {
    setControls({ [name]: { value: value } });
    setFormValid((prev) => ({ ...prev, [name]: validation }));
  };

  const autoCompleteHandler = (e, value) => {
    const controlName = e.target.id.split("-")[0];
    setControls({ [controlName]: { value: value } });
  };

  const onChangeToggle = (name, key, value) => {
    setControls({ [name]: { value: value } });
  };

  useEffect(() => {
    try {
      _toggleNChangeType[0].disabled = controls.isPercent.value.value;
      let _value = controls.changeType.value;
      if (
        controls.isPercent.value.value &&
        _value.value === _toggleNChangeType[0].value
      )
        _value = _toggleNChangeType[1];
      setControls({
        changeType: { arrayItems: _toggleNChangeType, value: _value },
      });
    } catch {
      _toggleNChangeType[0].disabled = false;
      setControls({
        changeType: {
          arrayItems: _toggleNChangeType,
          value: _toggleNChangeType[1],
        },
      });
    }
  }, [controls.isPercent?.value?.value]);

  const handleDialog = () => {
    setOpenDialog(!openDialog);
  };

  const onFinish = async (e) => {
    e.preventDefault();
    const { yaraghBrand, price, isPercent, changeType } = controls;
    if (
      !R.isEmpty(formValid) &&
      Object.values(formValid).every((item) => item === true)
    ) {
      if (isPercent.value.value && price.value > 100) {
        showNotify({
          text: t("wrongPercentage"),
          customClass: "error",
        });
      } else {
        try {
          setLoading(true);
          const data = {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
            IsPercent: isPercent.value.value,
            Value: +price.value,
            IdBrand: yaraghBrand.value.Id,
            TypeAction: +changeType.value.value,
          };
          await dispatch(updatePriceBrandGroup(data));
          handleDialog();
          const paramsMahdoode = {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
            IdPop: +selectedBazsho.Id,
            Name: mahdoodeDataSearch?.Name,
            Limit: mahdoodeDataPagination.Limit,
            Page: mahdoodeDataPagination.Page,
          };
          await dispatch(getMahdoode(paramsMahdoode));
          setLoading(false);
        } catch (e) {
          showNotify({
            text: t("correctFormDataRequired"),
            customClass: "error",
          });
          setLoading(false);
        }
        handleDialog();
      }
    } else {
      setCheckValid(true);
      showNotify({
        text: t("correctFormDataRequired"),
        customClass: "error",
      });
    }
  };

  useEffect(() => {
    if (openDialog) {
      setFormValid({});
      if (brandYaraghList)
        setControls({ yaraghBrand: { value: brandYaraghList[0] } });
      setControls({ price: { value: 0 } });
      setControls({ isPercent: { value: toggleNPercentRiyal[0] } });
      _toggleNChangeType[0].disabled = true;
      setControls({
        changeType: {
          arrayItems: _toggleNChangeType,
          value: _toggleNChangeType[1],
        },
      });
    }
  }, [openDialog]);

  return (
    <>
      <MuiButton
        loading={loading}
        color="secondary"
        title={<Translator id={"priceChangeInGroup"} />}
        onClick={handleDialog}
        disabled={selectedBrandYaragh?.Disable}
      />
      <Dialog
        dir={direction}
        open={openDialog}
        onClose={handleDialog}
        fullWidth
        maxWidth="xs"
      >
        <form onSubmit={onFinish}>
          <div className="dialogHeader">
            <p>{<Translator id={"priceChangeInGroup"} />}</p>
          </div>
          <DialogContent>
            <Grid container spacing={2}>
              {Object.keys(controls)
                .filter((key) => controls[key].row === 1)
                .map((key, index) => {
                  return (
                    <Grid
                      item
                      sm={controls[key].col.sm}
                      xs={controls[key].col.xs}
                      key={key + index}
                    >
                      {controls[key].type === "select" && (
                        <MuiAutoComplete
                          loading={loading}
                          options={controls[key].selectItems}
                          label={<Translator id={key} />}
                          value={controls[key].value}
                          id={key}
                          onChange={autoCompleteHandler}
                        />
                      )}
                      {controls[key].type === "price" && (
                        <Input
                          setValue={setValue.bind(this)}
                          value={controls[key].value}
                          name={key}
                          placeholder={t(key)}
                          validation={
                            controls[key].relation &&
                            controls[controls[key].relation].value.value
                              ? {
                                  ...controls[key].validation,
                                  ...controls[controls[key].relation]
                                    .ValidationPlus,
                                }
                              : controls[key].validation
                          }
                          checkValid={checkValid}
                          label={<Translator id={key} />}
                          type={controls[key].type}
                          endIcon={
                            controls.isPercent.value.value ? (
                              "%"
                            ) : (
                              <Translator id="moneyUnit" />
                            )
                          }
                          radioGroup={{
                            name: controls[key].relation,
                            value: controls[controls[key].relation].value,
                            items: controls[controls[key].relation].arrayItems,
                            onChange: onChangeToggle,
                          }}
                        />
                      )}
                      {controls[key].type === "toggle" && (
                        <MuiRadioGroup
                          name={key}
                          label={<Translator id={key} />}
                          value={controls[key].value}
                          items={controls[key].arrayItems}
                          onChange={onChangeToggle}
                          translate={true}
                          className="horizontalRadio"
                        />
                      )}
                    </Grid>
                  );
                })}
            </Grid>
          </DialogContent>
          <DialogActions>
            <MuiButton
              color="primary"
              type="submit"
              title={<Translator id="button_save" />}
            />
            <MuiButton
              onClick={handleDialog}
              title={<Translator id="enseraf" />}
            />
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
}

export default ChangeGroupPrice;
